<template>
  <div
    v-if="showValidation"
    class="body-sm flex flex-col gap-2"
  >
    <p
      class="font-semibold"
      v-text="'Passwords must:'"
    />
    <ul class="flex flex-col gap-2">
      <li class="flex items-center gap-2">
        <IconCircleCheckFilled
          :class="password.length >= MIN_PASSWORD_LENGTH ? 'text-green' : 'text-gray-300'"
          :size="24"
          aria-hidden="true"
        />
        <span v-text="`Have at least ${MIN_PASSWORD_LENGTH} characters`" />
      </li>
      <li class="flex items-center gap-2">
        <IconCircleCheckFilled
          :class="password && !error.includes('number') ? 'text-green' : 'text-gray-300'"
          :size="24"
          aria-hidden="true"
        />
        <span v-text="'Include at least 1 numeric digit'" />
      </li>
      <li class="flex items-center gap-2">
        <IconCircleCheckFilled
          :class="password && !error.includes('lowercase') ? 'text-green' : 'text-gray-300'"
          :size="24"
          aria-hidden="true"
        />
        <span v-text="'Include at least 1 lowercase character'" />
      </li>
      <li class="flex items-center gap-2">
        <IconCircleCheckFilled
          :class="password && !error.includes('uppercase') ? 'text-green' : 'text-gray-300'"
          :size="24"
          aria-hidden="true"
        />
        <span v-text="'Include at least 1 uppercase character'" />
      </li>
      <li class="flex items-center gap-2">
        <IconCircleCheckFilled
          :class="password && !error.includes('special') ? 'text-green' : 'text-gray-300'"
          :size="24"
          aria-hidden="true"
        />
        <span v-text="'Include at least 1 special character'" />
      </li>
    </ul>
  </div>
</template>

<script lang="ts" setup>
import { IconCircleCheckFilled } from '@tabler/icons-vue'

defineOptions({
  name: 'BasePasswordValidation',
})

withDefaults(
  defineProps<{
    error?: string
    password: string
    showValidation?: boolean
  }>(),
  {
    error: '',
    showValidation: false,
  },
)

const MIN_PASSWORD_LENGTH = 6
</script>
